/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChunkResponse } from './ChunkResponse';
import {
    ChunkResponseFromJSON,
    ChunkResponseFromJSONTyped,
    ChunkResponseToJSON,
} from './ChunkResponse';

/**
 * 
 * @export
 * @interface ChunkStatusResponse
 */
export interface ChunkStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof ChunkStatusResponse
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ChunkStatusResponse
     */
    id: string;
    /**
     * 
     * @type {ChunkResponse}
     * @memberof ChunkStatusResponse
     */
    result: ChunkResponse;
}

/**
 * Check if a given object implements the ChunkStatusResponse interface.
 */
export function instanceOfChunkStatusResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function ChunkStatusResponseFromJSON(json: any): ChunkStatusResponse {
    return ChunkStatusResponseFromJSONTyped(json, false);
}

export function ChunkStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunkStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'id': json['id'],
        'result': ChunkResponseFromJSON(json['result']),
    };
}

export function ChunkStatusResponseToJSON(value?: ChunkStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'id': value.id,
        'result': ChunkResponseToJSON(value.result),
    };
}

